export const RECORDS_PER_PAGE = 5;
